import React from "react";

const GithubIconSvg = (props: React.ComponentProps<"svg">) => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1427_3369)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99922 0C4.8565 0 0.699219 4.12564 0.699219 9.2292C0.699219 13.309 3.36296 16.7623 7.05832 17.9847C7.52025 18.0764 7.68962 17.7861 7.68962 17.5416C7.68962 17.3277 7.67422 16.5942 7.67422 15.8302C5.08746 16.3803 4.54856 14.7301 4.54856 14.7301C4.13283 13.6604 3.51693 13.3854 3.51693 13.3854C2.67008 12.82 3.57852 12.82 3.57852 12.82C4.51776 12.8812 5.01048 13.7674 5.01048 13.7674C5.84193 15.1732 7.1815 14.7759 7.72041 14.5314C7.7974 13.9355 8.04376 13.5229 8.30551 13.2937C6.24227 13.0798 4.07124 12.2852 4.07124 8.74024C4.07124 7.73175 4.44077 6.90662 5.02587 6.26486C4.93349 6.03565 4.61015 5.08828 5.11826 3.82003C5.11826 3.82003 5.90352 3.57555 7.67422 4.7674C8.41329 4.56876 9.21395 4.4618 9.99922 4.4618C10.7845 4.4618 11.5851 4.56876 12.3242 4.7674C14.0949 3.57555 14.8802 3.82003 14.8802 3.82003C15.3883 5.08828 15.0649 6.03565 14.9726 6.26486C15.5731 6.90662 15.9272 7.73175 15.9272 8.74024C15.9272 12.2852 13.7562 13.0645 11.6775 13.2937C12.0163 13.584 12.3088 14.1341 12.3088 15.0051C12.3088 16.2428 12.2934 17.236 12.2934 17.5416C12.2934 17.7861 12.4628 18.0764 12.9247 17.9847C16.6201 16.7623 19.2838 13.309 19.2838 9.2292C19.2992 4.12564 15.1265 0 9.99922 0Z"
        fill="currentColor"
      />
      <path
        d="M4.22514 13.2479C4.20974 13.2937 4.13275 13.309 4.07116 13.2785C4.00957 13.2479 3.96338 13.1868 3.99418 13.1409C4.00957 13.0951 4.08656 13.0798 4.14815 13.1104C4.20974 13.1409 4.24053 13.2021 4.22514 13.2479Z"
        fill="currentColor"
      />
      <path
        d="M4.59398 13.6604C4.54779 13.7062 4.45541 13.6756 4.40922 13.6145C4.34763 13.5534 4.33223 13.4617 4.37842 13.4159C4.42461 13.37 4.5016 13.4006 4.56319 13.4617C4.62478 13.5381 4.64018 13.6298 4.59398 13.6604Z"
        fill="currentColor"
      />
      <path
        d="M4.96511 14.1953C4.90352 14.2412 4.81113 14.1953 4.76494 14.1189C4.70335 14.0425 4.70335 13.9356 4.76494 13.905C4.82653 13.8592 4.91892 13.905 4.96511 13.9814C5.0267 14.0578 5.0267 14.1495 4.96511 14.1953Z"
        fill="currentColor"
      />
      <path
        d="M5.47375 14.7147C5.42756 14.7758 5.31978 14.7606 5.22739 14.6842C5.15041 14.6078 5.11961 14.5008 5.1812 14.455C5.22739 14.3938 5.33517 14.4091 5.42756 14.4855C5.50455 14.5466 5.51994 14.6536 5.47375 14.7147Z"
        fill="currentColor"
      />
      <path
        d="M6.16462 15.0051C6.14922 15.0815 6.04144 15.1121 5.93366 15.0815C5.82588 15.051 5.76429 14.9593 5.77969 14.8982C5.79508 14.8218 5.90286 14.7912 6.01065 14.8218C6.11843 14.8523 6.18002 14.9287 6.16462 15.0051Z"
        fill="currentColor"
      />
      <path
        d="M6.91986 15.0662C6.91986 15.1426 6.82748 15.2038 6.7197 15.2038C6.61192 15.2038 6.51953 15.1426 6.51953 15.0662C6.51953 14.9898 6.61192 14.9287 6.7197 14.9287C6.82748 14.9287 6.91986 14.9898 6.91986 15.0662Z"
        fill="currentColor"
      />
      <path
        d="M7.62713 14.9439C7.64253 15.0203 7.56554 15.0967 7.45776 15.112C7.34998 15.1272 7.25759 15.0814 7.2422 15.005C7.2268 14.9286 7.30379 14.8522 7.41157 14.8369C7.51935 14.8216 7.61173 14.8675 7.62713 14.9439Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1427_3369">
        <rect
          width="18.6"
          height="18"
          fill="currentColor"
          transform="translate(0.699219)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default GithubIconSvg;
